import { render } from "./BasicExpenseReport.vue?vue&type=template&id=1c92231f&scoped=true"
import script from "./BasicExpenseReport.vue?vue&type=script&lang=js"
export * from "./BasicExpenseReport.vue?vue&type=script&lang=js"

import "./BasicExpenseReport.vue?vue&type=style&index=0&id=1c92231f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c92231f"]])

export default __exports__